module.exports = __webpack_public_path__ + "static/img/77-2.4f9e638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/77-2.jpg
// module id = VsMM
// module chunks = 0